import * as $ from 'jquery';
import * as PrintContent from './printContent';

export function initialize(): void {
    $('.js-print').on('click', print);
}

function print(event): void {
    event.preventDefault();

    const $xmlContent = $('.xml_content');
    const content = generatePrintContent($xmlContent);

    if (content.html.length < 3) {
        return;
    }

    sendUserHasPrinted();

    PrintContent.print(
        `<article class='xml_document'>
            <div class='xml_content'>${washHtml(content.html)}</div>
        </article>`,
        content.chapter
    );
}

function sendUserHasPrinted() {
    const Http = new XMLHttpRequest();
    const url = "/api/badgification/1.0/addbadge/" + 5;
    Http.open("GET", url);
    Http.send();
}

function washHtml(html: string): any {
    let $washed = $('<div>').html(html);

    $washed
        .find('.part_functions, .func_popup, .note_functions')
        .remove();


    if ($washed.find('.xml_content').length > 0) {
        $washed = $washed.find(".xml_content:first");
    }

    return $washed.html();
}

function generatePrintContent($xmlContent: any): any {
    let html = $xmlContent.html();
    let chapter = '';
    const selection: any = window.getSelection();

    if (!selection.isCollapsed) {

        const rng = selection.getRangeAt(0);
        if (!rng.collapsed) {
            const docfrag = rng.cloneContents();
            const $tmpDiv = $('<div>');
            const $firstElement = $(selection.anchorNode);

            $(docfrag).appendTo($tmpDiv);
            html = `<div id='docContent'>${$tmpDiv.html()}</div>`;

            if ($firstElement.parent('h3').length === 0) {
                chapter = $firstElement.closest('div.niv2').find('h3.niv2').text();
            }

            if (chapter === '') {
                chapter = $firstElement.closest('div.niv1').find('h2.niv1').text();
            }
        }
    }

    return {
        chapter: chapter,
        html: html
    };
}